export const trackClick = (trackingUrl?: string) => {
  if (!trackingUrl) {
    return;
  }

  fetch(trackingUrl, {
    method: "HEAD",
    redirect: "error",
    keepalive: true,
  }).catch((err) => {
    console.debug("Track click failed:", err);
  });
};
